import numbro from 'numbro'

// Amounts typed and shown the way the Model Composer takes them: "15m", "15M", "15,000,000" and
// "15000000" are the same figure, and what a field shows is the compact form it will take back.

// The typed figure as a number, or NaN when it cannot be read. numbro.unformat matches its
// abbreviations in lower case only and returns undefined rather than NaN for anything it cannot read.
export function parseAmount (value) {
  const text = String(value === null || value === undefined ? '' : value).trim()
  if (text === '') return NaN
  const direct = Number(text)
  if (isFinite(direct)) return direct
  const parsed = numbro.unformat(text)
  if (isFinite(parsed)) return Number(parsed)
  const lowered = numbro.unformat(text.toLowerCase())
  return isFinite(lowered) ? Number(lowered) : NaN
}

// The compact form ("1.25m") with two decimals at most, so an edit round-trips through what is on
// screen.
export function formatAmount (value) {
  return numbro(Number(value) || 0).format({
    average: true,
    lowPrecision: false,
    mantissa: 2,
    optionalMantissa: true
  })
}

// The whole figure with thousands separators ("1,250,000"), for a field being edited.
export function formatFullAmount (value) {
  return numbro(Math.round(Number(value) || 0)).format({ thousandSeparated: true })
}
